import { Icon } from "@iconify/react";
import fileTextFill from "@iconify/icons-eva/file-text-fill";
import alertTriangleFill from "@iconify/icons-eva/alert-triangle-fill";
import {
  DnDashboardIcons,
  DnAffirmationIcons,
  DnGoalStatmentIcons,
  DnGratitudeIcons,
  DnMemoriesIcons,
  DnFaqIcons,
  DnVideos,
  DnPodsIcons,
  DnProgrammeIcons,
  DnQuotesIcons,
  DnVaultIcons,
} from "src/assets";

const dashboard_icon = DnDashboardIcons;
const goal_statement_icon = DnGoalStatmentIcons;
const programmes_icon = DnProgrammeIcons;
const vault_icon = DnVaultIcons;
const pods_icon = DnPodsIcons;
const affirmations_icon = DnAffirmationIcons;
const gratitude_icon = DnGratitudeIcons;
const quotes_icon = DnQuotesIcons;
const memories_icon = DnMemoriesIcons;
const video_icon = DnVideos;
const calender_icon = DnMemoriesIcons;
const support_ticket_icon = DnMemoriesIcons;
const faq_icon = DnFaqIcons;

const getIcon = (name) => {
  return <img src={name} width={22} height={22} />;
};

const sidebarConfig = (navbarList, consultantInfo, userInfo) => {
  let sidebarMenus = [];
  sidebarMenus.push({
    title: "dashboard",
    path: "/dashboard",
    icon: getIcon(dashboard_icon),
    matches: ["/dashboard", "/post-detail", "/video-detail"],
  });
  if (navbarList && navbarList.programmes) {
    sidebarMenus.push({
      title: "Programs",
      path: "/programs",
      icon: getIcon(programmes_icon),
      matches: [
        "/programs",
        "/lessons",
        "/recordings",
        "/lessons-recordings",
        "/study-session",
      ],
    });
  }
  if (navbarList && navbarList.calendar) {
    sidebarMenus.push({
      title: "calendar",
      path: "/calendar",
      icon: getIcon(calender_icon),
    });
  }
  if (navbarList && navbarList.pods) {
    sidebarMenus.push({
      title: "Community Rooms",
      path: "/community-rooms",
      icon: getIcon(pods_icon),
    });
  }
  if (navbarList && navbarList.the_vault) {
    sidebarMenus.push({
      title: "Replay Library",
      path: "/replay-library",
      icon: getIcon(vault_icon),
    });
  }
  if (
    userInfo &&
    userInfo.goal_statement_status &&
    navbarList &&
    navbarList.goal_statement
  ) {
    sidebarMenus.push({
      title: "goal statement",
      path: "/goal-statement",
      icon: getIcon(goal_statement_icon),
    });
  }
  if (navbarList && navbarList.self_image) {
    sidebarMenus.push({
      title: "self image",
      path: "/self-image",
      icon: getIcon(goal_statement_icon),
    });
  }
  if (navbarList && navbarList.journal_prompt) {
    sidebarMenus.push({
      title: "journal prompts",
      path: "/journal-prompt",
      icon: getIcon(goal_statement_icon),
    });
  }
  if (navbarList && navbarList.portals) {
    sidebarMenus.push({
      title: "Danielle's Events / Portals",
      path: "/portals",
      icon: getIcon(vault_icon),
    });
  }
  if (navbarList && navbarList.gratitude) {
    sidebarMenus.push({
      title: "gratitude",
      path: "/gratitude",
      icon: getIcon(gratitude_icon),
    });
  }
  if (navbarList && navbarList.affirmations) {
    sidebarMenus.push({
      title: "affirmations",
      path: "/affirmations",
      icon: getIcon(affirmations_icon),
    });
  }

  if (navbarList && navbarList.quotes) {
    sidebarMenus.push({
      title: "quotes",
      path: "/quotes",
      icon: getIcon(quotes_icon),
    });
  }
  if (navbarList && navbarList.memories) {
    sidebarMenus.push({
      title: "memories",
      path: "/memories",
      icon: getIcon(memories_icon),
    });
  }

  if (navbarList && navbarList.faq) {
    sidebarMenus.push({
      title: "FAQs",
      path: "/faqs",
      icon: getIcon(faq_icon),
    });
  }
  if (navbarList && navbarList.community_feeds) {
    sidebarMenus.push({
      title: "Community News Feed",
      path: "/community-news-feed",
      icon: getIcon(pods_icon),
    });
  }
  if (navbarList && navbarList.support_ticket) {
    sidebarMenus.push({
      title: "support ticket",
      path: "/support-ticket",
      icon: getIcon(support_ticket_icon),
    });
  }
  if (navbarList && navbarList.consultant_recordings) {
    consultantInfo !== null &&
      consultantInfo !== undefined &&
      consultantInfo !== "undefined" &&
      consultantInfo.status === true &&
      consultantInfo.team_type !== "team" &&
      sidebarMenus.push({
        title:
          consultantInfo.first_name +
          " " +
          consultantInfo.last_name +
          "'s Recording",
        path: "/consultant-recordings",
        icon: getIcon(vault_icon),
      });
  }

  if (navbarList && navbarList.helping_videos) {
    sidebarMenus.push({
      title: "Helping videos",
      path: "/helping-videos",
      icon: getIcon(video_icon),
    });
  }

  if (navbarList && navbarList.affiliate_links) {
    sidebarMenus.push({
      title: "Affiliate Links",
      path: "/affliate-links",
      icon: getIcon(programmes_icon),
    });
  }
  if (navbarList && navbarList.commission_details) {
    sidebarMenus.push({
      title: "Commission Detail",
      path: "/commission-detail",
      icon: getIcon(programmes_icon),
    });
  }

  return sidebarMenus;
};
export default sidebarConfig;
